import React from 'react';

import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';

import { PLAYER_STATUS } from '@/constants/player-constants';
import StatusIconComponent from '@/DesignSystem/features/status-icon/StatusIconComponent';

const NoticiaFlashAyudaModal = () => {
    const size = 50;
    return (
        <Box style={{ marginTop: '16px' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography id="modal-title" variant="h6" component="h2">
                    ¿Cómo funciona el estado de los jugadores?
                </Typography>
            </Box>

            {/* Modal Body */}
            <List>
                <ListItem style={{ paddingLeft: 0 }}>
                    <ListItemText
                        primary={
                            <Box display="flex" alignItems="center">
                                <StatusIconComponent status={PLAYER_STATUS.OK} width={size} height={size} />
                                <Typography variant="body1" ml={1}>
                                    Disponible
                                </Typography>
                            </Box>
                        }
                        secondary="Disponible para competir"
                    />
                </ListItem>
                <ListItem style={{ paddingLeft: 0 }}>
                    <ListItemText
                        primary={
                            <Box display="flex" alignItems="center">
                                <StatusIconComponent
                                    status={PLAYER_STATUS.DOUBTFUL}
                                    statusLevel={1}
                                    width={size}
                                    height={size}
                                />
                                <Typography variant="body1" ml={1}>
                                    Duda leve
                                </Typography>
                            </Box>
                        }
                        secondary="No está al 100% pero creemos que llega a la jornada. Utilizado también para ausencias al entrenamiento."
                    />
                </ListItem>
                <ListItem style={{ paddingLeft: 0 }}>
                    <ListItemText
                        primary={
                            <Box display="flex" alignItems="center">
                                <StatusIconComponent
                                    status={PLAYER_STATUS.DOUBTFUL}
                                    statusLevel={2}
                                    width={size}
                                    height={size}
                                />
                                <Typography variant="body1" ml={1}>
                                    Duda
                                </Typography>
                            </Box>
                        }
                        secondary="Podría no llegar a la jornada. Utilizado también para lesiones durante el partido dónde aún no se conoce parte médico oficial."
                    />
                </ListItem>
                <ListItem style={{ paddingLeft: 0 }}>
                    <ListItemText
                        primary={
                            <Box display="flex" alignItems="center">
                                <StatusIconComponent
                                    status={PLAYER_STATUS.INJURED}
                                    statusLevel={1}
                                    width={size}
                                    height={size}
                                />
                                <Typography variant="body1" ml={1}>
                                    Lesionado
                                </Typography>
                            </Box>
                        }
                        secondary="No disponible por lesión - máximo 3 meses. Ya hay parte médico oficial."
                    />
                </ListItem>
                <ListItem style={{ paddingLeft: 0 }}>
                    <ListItemText
                        primary={
                            <Box display="flex" alignItems="center">
                                <StatusIconComponent
                                    status={PLAYER_STATUS.INJURED}
                                    statusLevel={2}
                                    width={size}
                                    height={size}
                                />
                                <Typography variant="body1" ml={1}>
                                    Lesionado de larga duración
                                </Typography>
                            </Box>
                        }
                        secondary="No disponible por lesión - mínimo 3 meses. Ya hay parte médico oficial."
                    />
                </ListItem>
                <ListItem style={{ paddingLeft: 0 }}>
                    <ListItemText
                        primary={
                            <Box display="flex" alignItems="center">
                                <StatusIconComponent
                                    status={PLAYER_STATUS.INJURED}
                                    statusLevel={3}
                                    width={size}
                                    height={size}
                                />
                                <Typography variant="body1" ml={1}>
                                    Temas extradeportivos
                                </Typography>
                            </Box>
                        }
                        secondary="Causará baja por temas extradeportivos. Aplica a cláusulas del miedo, paternidad, etc."
                    />
                </ListItem>
                <ListItem style={{ paddingLeft: 0 }}>
                    <ListItemText
                        primary={
                            <Box display="flex" alignItems="center">
                                <StatusIconComponent
                                    status={PLAYER_STATUS.SANCTIONED}
                                    width={size}
                                    height={size}
                                />
                                <Typography variant="body1" ml={1}>
                                    Sancionado
                                </Typography>
                            </Box>
                        }
                        secondary="Sancionado, no disponible para competir. Tarjeta roja directa, acumulación de amarillas, etc."
                    />
                </ListItem>
            </List>
        </Box>
    );
};

export default NoticiaFlashAyudaModal;
